(() => {
  'use strict';
  const money = cents => '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  function init() {
    const box = document.querySelector('[data-slmg-buybox]');
    if (!box || box.dataset.slmgInit) return;
    box.dataset.slmgInit = '1';
    let cfg; try { cfg = JSON.parse(box.querySelector('[data-slmg-config]').textContent); } catch { return; }
    const radios = [...box.querySelectorAll('input[name="slmg-bundle"]')];
    const cover = box.querySelector('[data-slmg-cover]');
    const sticky = document.querySelector('[data-slmg-sticky]');
    const q = new URLSearchParams(location.search).get('variant');
    if (q) { const r = radios.find(x => x.value === q); if (r) r.checked = true; }
    if (!radios.some(r => r.checked) && radios[1]) radios[1].checked = true;

    function state() {
      const r = radios.find(x => x.checked) || radios[0];
      const qty = +r.dataset.qty, price = +r.dataset.price;
      const withCover = cover ? cover.checked : false;
      const coverTotal = withCover ? cfg.coverPrice * qty : 0;
      return { id: r.value, qty, price, title: r.dataset.title, withCover, coverTotal, total: price + coverTotal };
    }
    function render() {
      const s = state();
      radios.forEach(r => r.closest('[data-slmg-bundle]').classList.toggle('is-selected', r.checked));
      if (cover) {
        cover.closest('[data-slmg-addon]').classList.toggle('is-checked', cover.checked);
        box.querySelector('[data-slmg-cover-qty]').textContent = s.qty;
        box.querySelector('[data-slmg-cover-price]').textContent = money(cfg.coverPrice * s.qty);
        box.querySelector('[data-slmg-cover-compare]').textContent = money(cfg.coverCompare * s.qty);
      }
      const gift = box.querySelector('[data-slmg-gift-cover]');
      if (gift) gift.classList.toggle('is-locked', s.qty < 2);
      document.querySelectorAll('[data-slmg-checkout-label]').forEach(el => { el.textContent = 'Checkout Securely · ' + money(s.total); });
      const sub = document.querySelector('[data-slmg-sticky-sub]');
      if (sub) sub.textContent = s.title + (s.withCover ? ' + cover x' + s.qty : '') + ' · ' + money(s.total);
      const idInput = box.querySelector('[data-slmg-form-id]');
      if (idInput) idInput.value = s.id;
      const url = new URL(location.href); url.searchParams.set('variant', s.id); history.replaceState(null, '', url);
    }
    async function checkout(btn) {
      const s = state(), err = box.querySelector('[data-slmg-checkout-error]');
      if (cfg.draft) { err.textContent = 'Preview: checkout is disabled on the draft route.'; err.hidden = false; return; }
      const items = [{ id: +s.id, quantity: 1 }];
      if (s.withCover && cfg.cover) items.push({ id: cfg.cover, quantity: s.qty });
      if (cfg.ship) items.push({ id: cfg.ship, quantity: 1 });
      if (cfg.warranty) items.push({ id: cfg.warranty, quantity: 1 });
      if (s.qty >= 2 && cfg.coverGift) items.push({ id: cfg.coverGift, quantity: 1 });
      document.querySelectorAll('[data-slmg-checkout]').forEach(b => { b.disabled = true; b.classList.add('is-busy'); });
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.description || j.message || 'Could not add to cart'); }
        location.href = '/checkout';
      } catch (e) {
        err.textContent = e.message; err.hidden = false;
        document.querySelectorAll('[data-slmg-checkout]').forEach(b => { b.disabled = false; b.classList.remove('is-busy'); });
      }
    }
    box.addEventListener('change', e => { if (e.target.matches('input[name="slmg-bundle"], [data-slmg-cover]')) render(); });
    document.addEventListener('click', e => { const b = e.target.closest('[data-slmg-checkout]'); if (b) { e.preventDefault(); checkout(b); } });
    document.addEventListener('click', e => { if (e.target.closest('[data-medigel-scroll-buy], a[href="#slmg-buy"]')) { e.preventDefault(); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); } });
    if (sticky) {
      const update = () => { const r = box.getBoundingClientRect(); sticky.hidden = !(r.bottom < 0 || r.top > innerHeight); };
      addEventListener('scroll', update, { passive: true }); update();
    }
    render();
    stock(box);
  }
  // Stock counter: same behaviour as the reference store (random start 140-160, decays toward a floor, resets hourly).
  function stock(scope) {
    const wrap = scope.querySelector('[data-medigel-stock]'); if (!wrap || wrap.__init) return; wrap.__init = true;
    const numEl = wrap.querySelector('[data-medigel-stock-num]'), barEl = wrap.querySelector('[data-medigel-stock-bar]');
    const FLOOR = 9, MIN = 140, MAX = 160, RESET = 3600000, KEY = 'slmg_stock_state', MIN_DELAY = 10000, MAX_DELAY = 110000;
    const fresh = () => { const s = MIN + Math.floor(Math.random() * (MAX - MIN + 1)); return { stock: s, start: s, startedAt: Date.now() }; };
    let st; try { st = JSON.parse(localStorage.getItem(KEY)); } catch { st = null; }
    if (!st || typeof st.stock !== 'number' || Date.now() - st.startedAt >= RESET) st = fresh();
    const save = () => { try { localStorage.setItem(KEY, JSON.stringify(st)); } catch {} };
    const paint = () => { numEl.textContent = st.stock; if (barEl) barEl.style.width = Math.max(6, Math.round((st.stock / st.start) * 48)) + '%'; };
    const tick = () => { if (st.stock <= FLOOR) return; st.stock -= 1; save(); paint(); const p = 1 - Math.max(0, st.stock - FLOOR) / Math.max(1, st.start - FLOOR); setTimeout(tick, MIN_DELAY + (MAX_DELAY - MIN_DELAY) * p); };
    save(); paint(); setTimeout(tick, MIN_DELAY);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
